import { axios } from '@/lib/axios';
import { ExtractFnReturnType, QueryConfig } from '@/lib/react-query';
import { Price } from '@/types';
import { useQuery } from '@tanstack/react-query';

export const getPriceList = (
  promotion: string | null,
  isoCountryCode?: string
): Promise<Price[]> => {
  return axios.get('/api/v1/payments/price_lists', {
    params: {
      promotion,
      isoCountryCode,
    },
  });
};

type QueryFnType = typeof getPriceList;

type usePriceListsOptions = {
  promotion: string | null;
  isoCountryCode?: string;
  config?: QueryConfig<QueryFnType>;
};

export const usePriceLists = ({
  promotion,
  isoCountryCode,
  config = {},
}: usePriceListsOptions) => {
  return useQuery<ExtractFnReturnType<QueryFnType>>({
    ...config,
    queryKey: ['payments/price_lists', { promotion, isoCountryCode }],
    queryFn: () => getPriceList(promotion, isoCountryCode),
  });
};
